import React from 'react';
import { Breadcrumb, Icon } from 'antd';

import './breadcrumb.css';

const { Item } = Breadcrumb;

const createBreadItems = (array) => {
    return array.map( (e,i) => {
        if ( e.href ) {
            return (
                <Item key={ i } href={ e.href }>
                    { e.icon && <Icon type={ e.icon } /> }
                    { e.text && <span>{ e.text }</span>}
                </Item>
            );
        } else {
            return (
                <Item key={ i }>
                    { e.icon && <Icon type={ e.icon } /> }
                    { e.text && <span>{ e.text }</span>}
                </Item>
            );
        }
    });
}; 

export default ({ paths }) => (
    <Breadcrumb className='breadcrumb'>
        { createBreadItems(paths)}
    </Breadcrumb>
);


// WEBPACK FOOTER //
// ./src/App/components/breadcrumb/breadcrumb.js